// extracted by mini-css-extract-plugin
export default {"transparent":"CustomButton_transparent__eFoJt","blue":"CustomButton_blue__yADON"};